import { render, staticRenderFns } from "./select-audit-logs-item-types.vue?vue&type=template&id=fa3421d6&scoped=true&"
import script from "./select-audit-logs-item-types.vue?vue&type=script&lang=js&"
export * from "./select-audit-logs-item-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3421d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa3421d6')) {
      api.createRecord('fa3421d6', component.options)
    } else {
      api.reload('fa3421d6', component.options)
    }
    module.hot.accept("./select-audit-logs-item-types.vue?vue&type=template&id=fa3421d6&scoped=true&", function () {
      api.rerender('fa3421d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/audit_logs/partials/select-audit-logs-item-types.vue"
export default component.exports